import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../Layouts/Spinner";

import ReactSelect from "react-select";
import { addSizeValidation } from "../../../Constant/constant";
import { addSize, getSingleSize, updateOneSIze } from "../../../../redux/size/action";
import { usePermissions } from "../../../../Hooks/usePermissions";
import { MENU, PERMISSION } from "../../../../lib/permissions";

const UpdateSize = () => {
  const { id } = useParams()
  const [loading, setLoading] = useState(false);
  const [selectStatus, setSelectStatus] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { hasAction } = usePermissions();
  const singleSize = useSelector((state) => state.reusableSlice.singleSize)
  console.log(singleSize, "sdfsfsfsf")

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      status: singleSize.status || "",
      name: singleSize.name || "",
      ar_name: singleSize.ar_name || "",
    },
    validationSchema: addSizeValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      id: singleSize?.id,
      ...values,
    };
    dispatch(updateOneSIze(data, setLoading, navigate));
  };

  const handleChangeStatus = (e) => {
    const gender = e.target.value;
    setSelectStatus(gender);
    formik.setFieldValue("status", Number(gender));
  };

  useEffect(() => {
    if (id) {
      dispatch(getSingleSize(id))
    }
  }, [dispatch])



  const isEditable = hasAction(MENU.CATALOGUE, PERMISSION.EDIT);

  console.log(formik.values, "sadfsfdsfsfdsfsd");
  return (
    <div className="card-head ">
      <div className="sub-head">
        <h4 >Update Size</h4>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="row ">
          <div className="col-3 ">
            <div style={{ position: 'sticky', top: '0' }} className="add-category-row d-flex flex-column">
              <div className="add-category-wrapper ">
                <div className="addcategory-padding">
                  <label htmlFor="status">Status</label>
                  <select
                  disabled={!isEditable}
                    id="status"
                    title="status"
                    className="form-control"
                    onChange={handleChangeStatus}
                    onBlur={formik.handleBlur}
                    value={formik.values.status}
                  >
                    <option value="">Select Status</option>
                    <option value="1">Active</option>
                    <option value="2">Inactive</option>
                  </select>
                  {formik.touched.status && formik.errors.status ? (
                    <div className="error">{formik.errors.status}</div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className="col-9">
            <div className=" form-group ">
              <label>Name</label>
              <input
              disabled={!isEditable}
                type="text"
                className="form-control"
                placeholder="Enter name"
                name="name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />
              {formik.touched.name && formik.errors.name ? (
                <div className="error">{formik.errors.name}</div>
              ) : null}
            </div>

            <div className=" form-group">
              <label>Ar Name</label>
              <input
              disabled={!isEditable}
                type="text"
                className="form-control"
                placeholder="Enter ar name"
                name="ar_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.ar_name}
              />
              {formik.touched.ar_name && formik.errors.ar_name ? (
                <div className="error">{formik.errors.ar_name}</div>
              ) : null}
            </div>
            <div
              className="d-flex align-items-center justify-content-between back-update "
              style={{ columnGap: "20px" }}
            >
              <button
                className="back-btn"
                onClick={() => {
                  navigate("/size");
                }}
                style={{ width: "max-content" }}
              >
                Back
              </button>
             { isEditable && (
               <button
               className="submit-btn   "
               style={{ width: "max-content" }}
               type="submit"
             >
               {!loading ? "Submit" : <Spinner />}
             </button>
             )}
            </div>
          </div>




        </div>

      </form>
    </div>
  );
};

export default UpdateSize;

